import { useAuthStore } from '@/stores/auth-store';

/**
 * Returns the authenticated user's ID.
 * Throws if called when no user is authenticated.
 *
 * Use in services and stores that need the userId without passing it as a parameter.
 * Do NOT call inside React components — use `useAuthStore` there instead.
 */
export function getCurrentUserId(): string {
  const user = useAuthStore.getState().user;
  if (!user) {
    throw new Error('getCurrentUserId called without an authenticated user');
  }
  return user.id;
}
